import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/library/reservation/punishments', config);
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/library/reservation/punishments/' + id);
}

const exportExcel = (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/library/reservation/punishments/excel-export',{...config,responseType:'arraybuffer'})
}
const cancelReservation = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/library/reservation/punishments/cancel/'+id, data);
}

export default {
    getAll,
    get,
    exportExcel,
    cancelReservation
}
